import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border border-gray-200 rounded-xl p-5 mb-5" }
const _hoisted_2 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-base text-gray-800" }, "Komisi Per Penumpang", -1)
const _hoisted_4 = { class: "pi pi-info-circle text-blue-500 cursor-pointer text-base" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm text-gray-800 block mb-1" }, "Komisi Mandoran Per Penumpang (Rp)", -1)
const _hoisted_6 = { class: "w-72" }
const _hoisted_7 = { class: "p-inputgroup flex-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp", -1)
const _hoisted_9 = { class: "invalid-feedback text-xs text-red-500 mt-1" }


import InputNumber from 'primevue/inputnumber'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormPassengerCommission',
  props: {
    values: null,
    errors: null
  },
  emits: ["change-number", "blur-field"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change-number', field: any, val: any): void
  (e: 'blur-field', field: any): void
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("i", _hoisted_4, null, 512), [
        [
          _directive_tooltip,
          'Komisi yang akan diterima Mandoran per 1 penumpang.',
          void 0,
          { top: true }
        ]
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_unref(InputNumber), {
          modelValue: __props.values.passengerCommissionAmount,
          placeholder: "0",
          min: 0,
          max: 99999,
          locale: "id-ID",
          class: "w-full",
          inputClass: __props.errors.passengerCommissionAmount ? 'p-invalid w-full' : 'w-full',
          onInput: _cache[0] || (_cache[0] = (e) => emit('change-number', 'passengerCommissionAmount', e)),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => emit('change-number', 'passengerCommissionAmount', val)),
          onBlur: _cache[2] || (_cache[2] = () => emit('blur-field', 'passengerCommissionAmount'))
        }, null, 8, ["modelValue", "inputClass"])
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(__props.errors.passengerCommissionAmount), 1)
    ])
  ]))
}
}

})